import { bool, func, array } from 'prop-types'
import { callWithContext, kuiperClassNames } from '../utils'
import VersionListItem from '../VersionListItem'

import './styles.scss'

const isDiffEnabledForVersion = ({
  diffEnabled,
  editable,
  version,
  priorVersion,
}) => {
  const isCurrentlyEditing = version.current && editable
  const hasPriorVersion = !!priorVersion
  return diffEnabled && !isCurrentlyEditing && hasPriorVersion
}

function renderVersions({
  versions,
  diffEnabled,
  onDelete,
  onRestore,
  onSelect,
  editable,
}) {
  if (versions) {
    return versions.map((version, idx) => {
      const priorVersion = versions[idx + 1]
      return (
        <VersionListItem
          key={version.id}
          {...version}
          diffEnabled={isDiffEnabledForVersion({
            diffEnabled,
            editable,
            version,
            priorVersion,
          })}
          editable={editable}
          onDelete={callWithContext(onDelete, version)}
          onRestore={callWithContext(onRestore, version)}
          onSelect={callWithContext(onSelect, version)}
          priorVersion={priorVersion}
        />
      )
    })
  }
  return null
}

const VersionList = ({
  versions,
  diffEnabled = false,
  editable,
  onDelete,
  onRestore,
  onSelect,
}) => (
  <div className={kuiperClassNames('version-list')}>
    {renderVersions({
      versions,
      diffEnabled,
      onDelete,
      onRestore,
      onSelect,
      editable,
    })}
  </div>
)

VersionList.propTypes = {
  diffEnabled: bool,
  editable: bool,
  onDelete: func,
  onRestore: func,
  onSelect: func,
  versions: array,
}

export default VersionList
